<template>
  <div class="serviceGrid">
    <nav class="navbar navbar-light bg-light">
      <a class="navbar-brand" href="#">
        <img
          src="logo.png"
          width="30%"
          class="d-inline-block align-top"
          alt="Wide-Net.org"
        />
      </a>
    </nav>

    <div class="container">
      <div class="column-center">
        <div
          v-bind:key="serviceList.id"
          v-for="serviceList in groupedServiceList"
          class="row service-row"
        >
          <div
            v-bind:key="service.serviceID"
            v-for="service in serviceList"
            class="col-4 text-center service-item"
          >
            <font-awesome-icon :icon="service.serviceIcon" />
            <br />
            <a :href="service.serviceURL">{{service.serviceName}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'ServiceGrid',
  props: ['serviceList'],
  computed: {
    groupedServiceList() {
      return _.chunk(this.serviceList, 3);
    }
  },
  mounted() {
    // document.title = 'Wide-Gate';
  }
};
</script>

